/**
 * Plan copy for the Billing page, the checkout summary and the paywalls (EN-1026). Premium and
 * God Mode share one feature list on purpose: only the price and billing cadence differ.
 */
export const BASIC_PLAN_GROUPS = [
	{ title: 'Resume', items: ['Resume builder · 1 upload', '5 bullet point generations', 'Limited recommendations'] },
	{ title: 'Apply', items: ['5 AutoApply uses', '3 cover letter generations', '1 networking message', '30 tracked applications'] },
	{ title: 'Learn & Grow', items: ['1 InterviewAI training', 'Limited Learning Hub access'] },
];

export const PREMIUM_PLAN_GROUPS = [
	{ title: 'Resume', items: ['Unlimited resume uploads', 'Unlimited bullet points generation', 'Unlimited recommendations'] },
	{
		title: 'Apply',
		items: ['Unlimited AutoApply uses', 'Unlimited cover letters', 'Unlimited networking messages', 'Unlimited tracked applications'],
	},
	{ title: 'Learn & Grow', items: ['Unlimited InterviewAI training', 'Unlimited Learning Hub access'] },
];

export const COACHING_PLAN = {
	label: '1:1 Coaching Service',
	title: 'Custom',
	tagline: 'Personal guidance to move to the offer faster',
	introTitle: 'Alone in your job search?',
	introBody: 'There\'s nothing wrong, but it\'s also where most people get stuck. Book a free 1:1 with our team to see how we can help.',
	features: [
		'Guaranteed job offer in 120 days',
		'A tailored job-search strategy built for your goals',
		'Expert 1:1 help with your resume, networking & interviews',
		'Full Service Apply to apply for jobs on your behalf',
		'Continued guidance & accountability until you land an offer',
	],
};
